// extracted by mini-css-extract-plugin
export default {"main":"_217df19d1f _026136f2df","xmark":"cfc7f92c4c","fl_img":"_97f0f1f70c db708a07d2"};